module.exports = __webpack_public_path__ + "static/media/legalmindLogo.bf9b1c64.webp";